import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import { reactQueryGet } from "@circle-react/helpers/backendRequestHelpers";
import { internalApi } from "@circle-react/helpers/urlHelpers/internalApi";
import { useCommunityInboxStore } from "@circle-react/hooks/chatsV2/store";
import type { Chat } from "@circle-react/types/CommunityInbox/Chat";
import { useQuery } from "react-query";

import { useCommunityBotProfileSearch } from "./useCommunityBotProfileSearch";

interface MemberChatsResponse {
  records: Chat[];
}

export const useShouldShowAgentsTab = ({ enabled = true } = {}) => {
  const { botProfiles, isBotsLoading } = useCommunityBotProfileSearch({
    name: "",
    disabled: !enabled,
  });

  const { currentCommunity } = usePunditUserContext();
  const { memberChats } = useCommunityInboxStore();
  const hasBotProfiles = botProfiles?.length > 0;
  const hasLoadedMemberChats = memberChats?.length > 0;

  const { data: existingMemberChats } = useQuery<MemberChatsResponse>({
    queryKey: ["community-inbox", "member-has-chats"],
    queryFn: () =>
      reactQueryGet(
        internalApi.communityInbox.index({
          params: { filter: "mine", has_messages: true, per_page: 1 },
        }),
      ),
    enabled:
      enabled &&
      !!currentCommunity?.ai_agents_feature_flag_enabled &&
      !isBotsLoading &&
      !hasBotProfiles &&
      !hasLoadedMemberChats,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });

  return (
    hasBotProfiles ||
    hasLoadedMemberChats ||
    (existingMemberChats?.records?.length ?? 0) > 0
  );
};
